const INVESTORS_SHORTCUTS = {
  IN: 'in',
  OUT: 'out',
  PROSPECT: 'prospect',
};

export default INVESTORS_SHORTCUTS;
